import React from "react";
import logo from "../Untitled.svg";
import { Links } from "../Data";
import { FaBars } from "react-icons/fa";
import { useGlobalContext } from "../context";
const Navbar = () => {
	const { openSidebar } = useGlobalContext();
	return (
		<nav className="navbar">
			<div className="nav-center">
				<img src={logo} alt="ibrahim" className="logo" />
				<div className="nav-links big-screen">
					<ul className="links">
						{Links.map((link) => {
							const { id, url, name } = link;
							return (
								<li key={id} className="link">
									<a href={url}>{name}</a>
								</li>
							);
						})}
					</ul><a href="#contact">
					<button className="contact">
						contact
					</button></a>
				</div>
				<button className="nav-toggle" onClick={openSidebar}>
					<FaBars />
				</button>
			</div>
		</nav>
	
	);
};

export default Navbar;
